import { twMerge } from 'tailwind-merge';
import cn from 'classnames';

// Merges strings classes to use in `className=...`
export const mergeClasses = (...classNames: string[]) =>
  twMerge(cn(classNames));
